import React from "react"

interface PlusLineIconProps {
  color?: string;
}

const PlusLineIcon: React.FC<PlusLineIconProps> = ({
  color = "currentColor",
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16675 9.99999H10.0001M10.0001 9.99999H15.8334M10.0001 9.99999V4.16666M10.0001 9.99999V15.8333"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PlusLineIcon
